module.exports = __webpack_public_path__ + "media/images/lb/081-4d2d211f836cacc31cb76bffca618166.svg";